import styled from 'styled-components';

export const Badge = styled.div`
  color: #fe9800;
  font-size: 11px;
  font-weight: 700;
  background-color: #f5f5f5;
  padding: 5px 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-transform: none;
  font-family: 'Lato';
  line-height: 10px; 
`;
